<template lang="pug">
section#v-highlight.container
  h2 HIGHLIGHT
  ul
    li
      iframe(width='480', height='280', src='https://www.youtube.com/embed/hvkdhtAGQbg' frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen)
      .title
        label 2018
        h3 CONNECT with AI
    li
      iframe(width='480', height='280', src='https://www.youtube.com/embed/8aROHisk9rY', frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowfullscreen)
      .title
        label 2017
        h3 CONNECT 2020
    li
      iframe(width='480', height='280', src='https://www.youtube.com/embed/4Or2fTQ18uI', frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', allowfullscreen)
      .title
        label 2016
        h3 CONNECT to Change
</template>

<script>
export default {
  name: 'Highlight',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-highlight
  padding-bottom: 10px
  padding-top: 60px
h2
  +font(42px, white, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 50px
ul
  list-style-type: none
  li
    display: flex
    margin-bottom: 50px
    iframe
      +border(1px, #DFFF00)
      padding: 10px
    .title
      margin-left: 40px
      padding-top: 40px
      label
        +font(48px, white, null, 1.49px, 800)
        font-family: 'Montserrat Alternates'
      h3
        +font(24px, black, null, null, bold)
        background-color: #DFFF00
        margin-left: 30px
        margin-top: 30px
        padding: 5px 10px
        width: 290px

@media (max-width: 1023px)
  #v-highlight
    padding-top: 30px
    padding-bottom: 0
  h2
    +font(30px, null, null, .75px)
    margin-bottom: 30px
  ul
    li
      flex-direction: column
      iframe
        +size(calc(100vw - 40px), 55vw)
        margin-bottom: 10px
      .title
        margin-left: 0
        padding-top: 0
        text-align: right
        label
          +font(30px, null, null, 1.12px)
          display: block
          margin-right: 170px
        h3
          +font(18px, null, null, null, null, left)
          margin-left: auto
          margin-top: 10px
          width: 220px
</style>
